<template>
  <v-container fluid class="pb-4">
    <v-row>
      <v-col v-if="!!generalError && !isDialogOpened" cols="12">
        <general-error v-if="!!generalError && !isDialogOpened" />
      </v-col>
      <v-col>
        <v-card>
          <v-toolbar dark color="primary">
            <v-row align-content="center">
              <v-col cols="10" align-self="center" class="text-left">
                <v-toolbar-title>
                  {{ $t('Условия и базис поставки Incoterms') }}
                </v-toolbar-title>
              </v-col>
              <v-col v-if="isAdmin" cols="2" align-self="center" class="text-right">
                <btn-icon-tip
                    icon="add"
                    icon-color="secondaryiconbtn"
                    :tip="$t('Добавить запись в справочник')"
                    @click="openAddDialog" />
              </v-col>
            </v-row>
          </v-toolbar>
          <v-card-text>
            <v-data-table
                :headers="headers"
                :items="items"
                :loading="isLoading"
                item-key="incotermId"
                :items-per-page="itemsPerPage"
                disable-filtering
                :locale="systemLocale">

              <template v-slot:progress>
                <v-progress-linear :active="isLoading" color="loader" indeterminate />
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.nameRu="{ item }">
                {{ item.nameRu }}
              </template>

              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.nameEn="{ item }">
                {{ item.nameEn }}
              </template>

              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.hasBasises="{ item }">
                <v-checkbox v-model="item.hasBasises" disabled />
              </template>

              <!-- eslint-disable-next-line vue/valid-v-slot -->
              <template v-slot:item.incotermId="{ item }">
                <btn-icon-tip
                    v-if="isAdmin"
                    icon="edit"
                    :tip="$t('Редактировать')"
                    @click="openEditDialog(item)" />
                <btn-icon-tip
                    v-if="item.canDelete"
                    icon="delete"
                    :tip="$t('Удалить')"
                    @click="openConfirmDialog(item.incotermId)" />

              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <delivery-basises-management
            ref="deliveryBasises"
            @edited="getIncoterms" />
      </v-col>
    </v-row>
    <incoterm-dialog
        v-if="incotermDialog.show"
        :dialog-prop="incotermDialog"
        @close="closeDialog('incotermDialog')" />
    <confirm-dialog
        v-if="confirmDialog.show"
        :dialog-prop="confirmDialog"
        @close="closeDialog('confirmDialog')" />
  </v-container>
</template>

<script>
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import IncotermDialog from './IncotermDialog.vue'
  import ConfirmDialog from '@/components/reused/common/ConfirmDialog.vue'
  import DeliveryBasisesManagement from '../DeliveryBasises/DeliveryBasisesManagement.vue'
  import { mapActions, mapState } from 'vuex'
  import { INCOTERMS_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      GeneralError,
      IncotermDialog,
      ConfirmDialog,
      DeliveryBasisesManagement
    },
    data () {
      return {
        isLoading: false,
        itemsPerPage: 10,
        incotermDialog: {
          show: false,
          incoterm: null,
          callback: null
        },
        confirmDialog: {
          text: null,
          additional: null,
          callback: null,
          warning: true,
          show: false
        }
      }
    },
    computed: {
      ...mapState(INCOTERMS_MANAGEMENT.NAMESPACE, {
        items: state => (state[INCOTERMS_MANAGEMENT.STATE.INCOTERMS] || [])
      }),
      headers () {
        const headers = [
          { text: this.$t('Наименование (RU)'), align: 'start', sortable: true, value: 'nameRu' },
          { text: this.$t('Наименование (EN)'), align: 'start', sortable: true, value: 'nameEn' },
          { text: this.$t('Наличие подчиненного справочника'), align: 'start', sortable: true, value: 'hasBasises' },
          { text: this.$t('Действия'), align: 'center', sortable: false, value: 'incotermId' }
        ]

        return headers
      },
      isDialogOpened () {
        return this.incotermDialog.show
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(vm.getIncoterms)
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(INCOTERMS_MANAGEMENT.NAMESPACE, {
        getIncotermsAction: INCOTERMS_MANAGEMENT.ACTIONS.GET_INCOTERMS,
        editIncotermAction: INCOTERMS_MANAGEMENT.ACTIONS.EDIT_INCOTERM,
        deleteIncotermAction: INCOTERMS_MANAGEMENT.ACTIONS.DELETE_INCOTERM,
        addIncotermAction: INCOTERMS_MANAGEMENT.ACTIONS.ADD_INCOTERM,
        clearIncotermsAction: INCOTERMS_MANAGEMENT.ACTIONS.CLEAR_INCOTERMS
      }),
      clearStore: async function () {
        return Promise.all(
          [
            this.clearIncotermsAction()
          ])
      },
      openAddDialog: function () {
        this.incotermDialog.callback = this.addIncoterm
        this.incotermDialog.show = true
      },
      openEditDialog: function (incoterm) {
        this.incotermDialog.incoterm = incoterm
        this.incotermDialog.callback = this.editIncoterm
        this.incotermDialog.show = true
      },
      openConfirmDialog: function (incotermId) {
        this.confirmDialog.text = this.$t('Запись справочника будет удалена. Продолжить?')
        this.confirmDialog.additional = { incotermId }
        this.confirmDialog.callback = this.deleteIncoterm
        this.confirmDialog.warning = true
        this.confirmDialog.show = true
      },
      addIncoterm: async function (incoterm) {
        try {
          this.isLoading = true
          await this.addIncotermAction(incoterm)
          this.isLoading = false
          this.refreshIncoterms()
          this.getIncoterms()
        } finally {
          this.isLoading = false
        }
      },
      editIncoterm: async function (incoterm) {
        try {
          this.isLoading = true
          await this.editIncotermAction(incoterm)
          this.isLoading = false
          this.refreshIncoterms()
          this.getIncoterms()
        } finally {
          this.isLoading = false
        }
      },
      refreshIncoterms: async function () {
        if (this.$refs.deliveryBasises?.refreshIncoterms) {
          this.$refs.deliveryBasises.refreshIncoterms()
        }
      },
      deleteIncoterm: async function (model) {
        try {
          this.isLoading = true
          await this.deleteIncotermAction(model)
          this.isLoading = false
          this.refreshIncoterms()
          this.getIncoterms()
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      },
      getIncoterms: async function () {
        try {
          this.isLoading = true
          await this.getIncotermsAction()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
